export default {
  methods: {
    async uploadImage(image) {
      const formData = new FormData();
      formData.append("file", image);
      // formData.append("upload_preset", "zunt8yrw");
      try {
        let response = await this.$_uploadImage(formData);
        // console.log(response, response.data.fileUrl);
        return response.data.fileUrl;
      } catch (error) {
        this.handleError(error);
      }
    },
    async updateProfileImage(imagePath, message="image uploaded successfully"){
      let imageUrl = await imagePath ;
      const userId = localStorage.getItem('userId');
      if(userId!== null){
      try{
          let response = await this.$_updateProfileImage({userId, imageUrl});
          if(response.data.success){
            this.generateToast( message, 'success');
            return response.data.user;
          }
        }catch(error){
          this.handleError(error);
        }
      }
    },
    async updateDocument(image, message="doc uploaded successfully"){
      const formData = new FormData();
      formData.append("file", image);
      // formData.append("upload_preset", "zunt8yrw");
      try {
        let response = await this.$_uploadDocs(formData);
        // console.log(response, response.data.fileUrl);
        this.generateToast( message, 'success');
        return response.data.fileUrl;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
